import {HttpClient, HttpContext} from '@angular/common/http';
import {inject, Service} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {SHOW_SUCCESS_TOAST} from '../context/http-context-token';
import {ApiResponse} from '../models/api.model';
import {ResetPasswordRequest} from '../models/auth.model';
@Service()
export class AuthApiService {
  private readonly baseUrl = environment.apiBaseUrl;
  http = inject(HttpClient);

  logout(): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.baseUrl}/auth/logout`, null);
  }
  fetchProfile(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.baseUrl}/auth/me`);
  }
  resetPassword(data: ResetPasswordRequest): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.baseUrl}/auth/password/reset-password`, data, {
      context: new HttpContext().set(SHOW_SUCCESS_TOAST, true),
    });
  }
}
